import { PASSPORT_EMAIL_VERIFICATION_DIALOG } from '@/features/verify-identity'
import { useRouter } from '@/shared/i18n'
import { useDialogState, useSession } from '@/shared/lib'

import { DIALOG } from './sign-up-guest'

export const useVerificationDialog = () => {
  const { isOpen, open, close, closeHandler } = useDialogState()
  const router = useRouter()
  const session = useSession()

  const handlePhoneDialogConfirm = async () => {
    close(DIALOG.PHONE_SUCCESS_DIALOG)

    await session.update()

    router.push(`/sign-up/guest/complete`)
  }

  const handlePassportEmailDialogConfirm = async () => {
    close(DIALOG.PASSPORT_SUCCESS_DIALOG)
    close(PASSPORT_EMAIL_VERIFICATION_DIALOG)

    await session.update()

    router.push(`/sign-up/guest/complete`)
  }

  const handlePassportAdminEmailDialogConfirm = async () => {
    close(DIALOG.PASSPORT_SUCCESS_ADMIN_DIALOG)
    close(PASSPORT_EMAIL_VERIFICATION_DIALOG)

    await session.update()

    router.push(`/sign-up/guest/complete`)
  }

  return {
    isOpen,
    open,
    close,
    closeHandler,
    handlePhoneDialogConfirm,
    handlePassportEmailDialogConfirm,
    handlePassportAdminEmailDialogConfirm,
  }
}
